<template>
    <div class="root-wrap">
        <div class="fx-fill fx-center-middle">
            <van-empty :image="require('@/assets/images/error/404.png')" description="您的页面丢失了"></van-empty>

            <div style="padding: 20px; word-break: break-all;">
                <div>FM</div>
                <div>{{ href }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            href: ''
        }
    },

    mounted() {
        this.href = location
    }
}
</script>